import React from 'react';

const HowItWorksSection = () => {
  const steps = [
    {
      step: 'STEP 1',
      title: 'Click a picture of your face in good lighting',
      image: 'https://customer-assets.emergentagent.com/job_614ed27a-ecfd-41c1-b18b-261fcf3d21d5/artifacts/nwwahl1n_4.png',
    },
    {
      step: 'STEP 2',
      title: 'Get to know your skin health',
      image: 'https://customer-assets.emergentagent.com/job_614ed27a-ecfd-41c1-b18b-261fcf3d21d5/artifacts/3in3pp18_5.png',
    },
    {
      step: 'STEP 3',
      title: 'Get products that work for you',
      image: 'https://customer-assets.emergentagent.com/job_614ed27a-ecfd-41c1-b18b-261fcf3d21d5/artifacts/g3li4tg9_Copy%20of%20Your%20paragraph%20text.png',
    },
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-brand-100 px-4 py-2 rounded-full mb-4">
            <div className="w-2 h-2 bg-brand-600 rounded-full"></div>
            <span className="text-brand-700 font-medium">How it works</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Simple steps to get personalised skincare
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Follow these simple steps to get lightning-fast personalised skincare products
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="mb-6">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full max-w-md h-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="inline-block bg-brand-100 text-brand-700 font-bold px-4 py-2 rounded-full text-sm">
                {item.step}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;